import React from 'react';
import { DownloadIcon } from 'lucide-react';

/**
 * Opens the browser print dialog with the print-only deck laid out one slide
 * per landscape page — "Save as PDF" produces the full 6-slide deck.
 */
export function DownloadPdfButton() {
  return <button type="button" onClick={() => window.print()} className="screen-only fixed bottom-[2.5vh] right-[2.5vw] z-50 inline-flex items-center gap-[0.6vw] rounded-full border border-[color:var(--sv-green)]/45 bg-[color:var(--sv-green)]/12 px-[1.4vw] py-[1.1vh] text-[clamp(10px,0.95vw,17px)] font-medium uppercase tracking-[0.2em] text-white backdrop-blur-sm transition-colors hover:bg-[color:var(--sv-green)]/22 focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sv-green)]" data-id="element-24" data-mp="2nojodaulxps5">
      <DownloadIcon className="h-[1.1em] w-[1.1em] text-[color:var(--sv-green)]" data-id="element-25" data-mp="3gb4d03jp7ns0" />
      Download PDF
    </button>;
}